
function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
}

const listenToCart = (callback) => {
    const ShopifyCartURLs = [
      "cart.js",
      "change.js"
    ];
  
    function isShopifyCartURL(url) {
      if (!url) return false;
      const path = url.split("/").pop().split("?")[0];
      return ShopifyCartURLs.includes(`${path}`);
    }
  
    function dispatchEvent(url, detail) {
      callback(detail)
    }
  
    function fetchOverride() {
      if (!window.fetch || typeof window.fetch !== "function") return;
    
      const originalFetch = window.fetch;
    
      window.fetch = function () {
        const url = typeof arguments[0] === "string" ? arguments[0] : arguments[0].url;
    
        // Skip Klevu fetches
        if (url.includes("klevu") || url.includes("klevuapi")) {
          return originalFetch.apply(this, arguments);
        }
    
        const response = originalFetch.apply(this, arguments);
    
        if (isShopifyCartURL(url)) {
          response.then((res) => {
            res
              .clone()
              .json()
              .then((data) => dispatchEvent(res.url, data));
          });
        }
    
        return response;
      };
    }

  
    function XHROverride() {
      if (!window.XMLHttpRequest) return;
  
      const originalOpen = window.XMLHttpRequest.prototype.open;
      window.XMLHttpRequest.prototype.open = function () {
        const url = arguments[1];
        this.addEventListener("load", function () {
          if (isShopifyCartURL(url)) {
            dispatchEvent(url, this.response);
          }
        });
        return originalOpen.apply(this, arguments);
      };
    }
  
    XHROverride();
    fetchOverride();
};


document.addEventListener('DOMContentLoaded', () => { 
    const fabricDrawer = document.querySelector('.prd-SwatchDrawer[data-fabric-drawer]')
    const fabricDrawerButton = document.querySelector('.prd-SwatchesFabric')
    const drawerCloseButtons = document.querySelectorAll('.prd-SwatchDrawer-Header-Button-Close');
    
    if (fabricDrawerButton) {
        fabricDrawerButton.addEventListener('click', () => {
            let openDrawer = document.querySelector('.prd-SwatchDrawer--open');
            if (openDrawer) {
                openDrawer.classList.remove('prd-SwatchDrawer--open')
            }
            fabricDrawer.classList.add('prd-SwatchDrawer--open')
            document.body.classList.add('body-SwatchDrawer--open')
        });
        
        const sampleTrigger = document.querySelector('.prd-SwatchDrawer-Header-Button-Swatches');

        if (sampleTrigger) {
            sampleTrigger.addEventListener('click', () => {
                fabricDrawer.classList.remove('prd-SwatchDrawer--open')
                sampleDrawer.classList.add('prd-SwatchDrawer--open')
            });
        }

        const fabricRenderImages = document.querySelectorAll('[data-fabric-drawer] .prd-SwatchDrawer-RenderImg');

        const fabrics = document.querySelectorAll('[data-fabric-drawer] .prd-SwatchDrawer-Item');
        const currentFabric = document.querySelector('[data-fabric-drawer] .prd-SwatchDrawer-Footer-Title');
        const currentFabricImage = currentFabric.querySelector('img');
        const currentFabricName = currentFabric.querySelector('span');
        const fabricConfirm = document.querySelector('[data-fabric-drawer] .prd-SwatchDrawer-Footer-Button-Select');

        fabrics.forEach(fabric => {
            fabric.addEventListener('click', async () => {
                if (fabric.dataset.selected === 'false') {
                    let currFabric = document.querySelector('[data-fabric-drawer] .prd-SwatchDrawer-Item[data-selected="true"]');
                    if (currFabric) currFabric.dataset.selected = 'false';
                    fabric.dataset.selected = 'true';
                    currentFabricImage.src = fabric.querySelector('.prd-SwatchDrawer-Item-Image img').src;
                    currentFabricName.innerHTML = fabric.dataset.name;
                    currentFabric.dataset.url = fabric.dataset.url;
                    let fabricRenderImage = document.querySelector(`[data-fabric-drawer] .prd-SwatchDrawer-RenderImg`);
                    let productData = await fetch(`${fabric.dataset.url}?view=json`);
                    let productDataResponse = await productData.json();
                    fabricRenderImage.src = productDataResponse.render_image;
                }
            });
        });
        
        fabricConfirm.addEventListener('click', async () => {
            if (!currentFabric.dataset.url) return;
            window.location.href = currentFabric.dataset.url;
        });
    }


    const sampleDrawer = document.querySelector('.prd-SwatchDrawer[data-sample-drawer]')
    const sampleDrawerButton = document.querySelector('.prd-SwatchSamples')
    const sampleAddToCartButton = document.querySelector('[data-sample-drawer] .prd-SwatchDrawer-Footer-Button-Select')
    
    if (sampleDrawerButton) {
        sampleDrawerButton.addEventListener('click', () => {
            let openDrawer = document.querySelector('.prd-SwatchDrawer--open');
            if (openDrawer) {
                openDrawer.classList.remove('prd-SwatchDrawer--open')
            }
            sampleDrawer.classList.add('prd-SwatchDrawer--open')
            document.body.classList.add('body-SwatchDrawer--open')
        });
        
        drawerCloseButtons.forEach(button => {
            button.addEventListener('click', () => {
                fabricDrawer.classList.remove('prd-SwatchDrawer--open')
                if (sampleDrawer) sampleDrawer.classList.remove('prd-SwatchDrawer--open')

                document.body.classList.remove('body-SwatchDrawer--open')
            });
        });
    } 
    
    const samples = document.querySelectorAll('[data-sample-drawer] .prd-SwatchDrawer-Item');
    
    samples.forEach(sample => {
        sample.addEventListener('click', () => {
            let selectedSamples = document.querySelectorAll('.prd-SwatchDrawer-SelectedItem[data-filled="true"]');
            if (selectedSamples.length === 6 && sample.dataset.selected === 'false') {
                return;
            }
            
            if (sample.dataset.selected === 'false') {
                let nextSample = document.querySelector('.prd-SwatchDrawer-SelectedItem[data-filled="false"]');
                sample.dataset.selected = 'true';
                nextSample.dataset.filled = 'true';
                nextSample.dataset.variant = sample.dataset.variant;
                nextSample.innerHTML = sample.querySelector('.prd-SwatchDrawer-Item-Image').innerHTML;
            } else {
                let currSample = document.querySelector(`.prd-SwatchDrawer-SelectedItem[data-variant="${sample.dataset.variant}"]`);
                sample.dataset.selected = 'false';
                currSample.dataset.filled = 'false';
                currSample.dataset.variant = '';
                currSample.innerHTML = currSample.dataset.index;
            }
            selectedSamples = document.querySelectorAll('.prd-SwatchDrawer-SelectedItem[data-filled="true"]');

            if (selectedSamples.length > 0) {
                sampleAddToCartButton.removeAttribute('disabled');
            } else {
                sampleAddToCartButton.setAttribute('disabled', 'disabled');
            }
        });
    });

    const form = document.querySelector('.custom-cart-trigger');
    
    if (sampleAddToCartButton) {

        sampleAddToCartButton.addEventListener('click', async () => {
            const selectedSamples = document.querySelectorAll('.prd-SwatchDrawer-SelectedItem[data-filled="true"]');
            if (selectedSamples.length === 0) {
                return;
            }
            const selectedSampleIds = [];
            let formId = false;
            selectedSamples.forEach((sample, i) => {
                if (i === 0) {
                    formId = sample.dataset.variant;
                } else {
                    selectedSampleIds.push(sample.dataset.variant);
                }
            });
            const atcResponse = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    items: selectedSampleIds.map(id => {
                        return {
                            id,
                            quantity: 1
                        }
                    })
                })
            });
            const atcData = await atcResponse.json();
            form.querySelector('[name="id"]').value = formId;
            form.dispatchEvent(new Event('submit', { bubbles: true,  }));
            //document.dispatchEvent(new CustomEvent('cart:updated'));
            
            if (sampleDrawer) {
                sampleDrawer.classList.remove('prd-SwatchDrawer--open')
            }
            document.body.classList.remove('body-SwatchDrawer--open')
            
            selectedSamples.forEach(sample => {
                sample.dataset.filled = 'false';
                sample.dataset.variant = '';
                sample.innerHTML = sample.dataset.index;
            });
            
            samples.forEach(sample => {
                sample.dataset.selected = 'false';
            });
        });
    }


    const styleDrawer = document.querySelector('.prd-SwatchDrawer[data-style-drawer]')
    const styleDrawerButton = document.querySelector('.prd-SwatchesStyle')
    if (styleDrawer && styleDrawerButton) {
        const styleDrawerCloseButton = styleDrawer.querySelector('.prd-SwatchDrawer-Header-Button-Close')

        styleDrawerButton.addEventListener('click', () => {
            let openDrawer = document.querySelector('.prd-SwatchDrawer--open');
            if (openDrawer) {
                openDrawer.classList.remove('prd-SwatchDrawer--open')
            }
            styleDrawer.classList.add('prd-SwatchDrawer--open')
            document.body.classList.add('body-SwatchDrawer--open')
        });

        styleDrawerCloseButton.addEventListener('click', () => {
            styleDrawer.classList.remove('prd-SwatchDrawer--open')
            document.body.classList.remove('body-SwatchDrawer--open')
        });
    }
    
    if (styleDrawer || fabricDrawer || sampleDrawer) {
        document.addEventListener('click', (e) => {
            if (
                (
                    (!styleDrawer || !styleDrawer.classList.contains('prd-SwatchDrawer--open'))
                    && !fabricDrawer.classList.contains('prd-SwatchDrawer--open')
                    && (!sampleDrawer || !sampleDrawer.classList.contains('prd-SwatchDrawer--open'))
                ) || e.target.closest('.prd-Swatches') || e.target.closest('.prd-SwatchSamples')
            ) return;
            let drawerFound = e.target.classList.contains('prd-SwatchDrawer') || e.target.closest('.prd-SwatchDrawer');

            if (!drawerFound) {
                let openDrawer = document.querySelector('.prd-SwatchDrawer--open');
                openDrawer.classList.remove('prd-SwatchDrawer--open')
                document.body.classList.remove('body-SwatchDrawer--open')
            }
        });
    }


    const optionDrawerButtons = document.querySelectorAll('.prd-SwatchesOption');
    optionDrawerButtons.forEach(button => {
        const optionDrawer = document.querySelector(`.prd-SwatchDrawer[data-option-drawer][data-option="${button.dataset.option}"]`)
        const drawerCloseButton = optionDrawer.querySelector('.prd-SwatchDrawer-Header-Button-Close')
        button.addEventListener('click', () => {
            optionDrawer.classList.add('prd-SwatchDrawer--open')
            document.body.classList.add('body-SwatchDrawer--open')
        });

        const optionItems = optionDrawer.querySelectorAll(`.prd-SwatchDrawer-Item`);
        const confirmButton = optionDrawer.querySelector('.prd-SwatchDrawer-Footer-Button-Select');
        const optionSelect = document.querySelector(`.prd-SwatchesOption[data-option="${button.dataset.option}"] .prd-DetailOffers_OptionSelect`);
        const selectedTitle = optionDrawer.querySelector('.prd-SwatchDrawer-Footer-Title span');
        const selectedImage = optionDrawer.querySelector('.prd-SwatchDrawer-Footer-Title img');

        const buttonImage = button.querySelector('img');
        const buttonTitle = button.querySelector('.prd-SwatchesSubtitle');

        optionItems.forEach(item => {
            item.addEventListener('click', () => {
                let currItem = optionDrawer.querySelector(`.prd-SwatchDrawer-Item[data-selected="true"]`);
                currItem.dataset.selected = 'false';
                item.dataset.selected = 'true';
                selectedTitle.innerHTML = item.dataset.name;
                selectedImage.src = item.querySelector('.prd-SwatchDrawer-Item-Image img').src;
                confirmButton.dataset.name = item.dataset.name;
            });
        });
        
        confirmButton.addEventListener('click', () => {
            optionDrawer.classList.remove('prd-SwatchDrawer--open')
            document.body.classList.remove('body-SwatchDrawer--open')
            optionSelect.value = confirmButton.dataset.name;
            buttonTitle.innerHTML = confirmButton.dataset.name;
            buttonImage.src = selectedImage.src;
            optionSelect.dispatchEvent(new Event('change', { bubbles: true }));
        });


        drawerCloseButton.addEventListener('click', () => {
            optionDrawer.classList.remove('prd-SwatchDrawer--open')
            document.body.classList.remove('body-SwatchDrawer--open')
        });
    });

    listenToCart((cart) => {
        if (isJsonString(cart)) {
            cart = JSON.parse(cart);
        }
        setTimeout(() => {
            const subtotal = document.querySelector('.psh-Footer_Subtotal');
            let subtotalAmount = 0;
            let cartSubtotal = 0;
            cart.items.map(item => {
                let itemElement = document.querySelector(`.psh-Item[data-key="${item.key}"]`);
                let multiplier = parseFloat(itemElement.dataset.multiplier);
                let price = parseFloat(item.original_price) * multiplier * item.quantity;
                cartSubtotal += parseFloat(item.original_price) * item.quantity;
                subtotalAmount += price;
            });

            if (subtotalAmount === cartSubtotal) {
                return;
            }
    
            subtotal.innerHTML = `${formatMoney(subtotalAmount, window.theme.moneyFormat)} <span class="price--rrp">(RRP: ${formatMoney(cartSubtotal, window.theme.moneyFormat)})</span>`;
        }, 1000);
    });



    let optionSelect = document.querySelector('.prd-DetailOffers_Options .prd-DetailOffers_OptionSelect');
    let variantSelect = document.querySelectorAll('#variant-listbox option');
    if (optionSelect && variantSelect) {
        // Josh Fix
            optionSelect.addEventListener('change', (e) => {
                const selectedVariantId = e.target.value;
                const currentOption = Array.from(variantSelect).find(option => option.value === selectedVariantId);
                if (!currentOption) return;

                const multiplier = parseFloat(currentOption.dataset.multiplier || 1);
                const price = parseFloat(currentOption.dataset.price || 0);

                const priceElement = document.querySelector('.prd-DetailPrice_Price');
                const rrpPrice = document.querySelector('.price--rrp');

                priceElement.innerHTML = formatMoney(price * multiplier, window.theme.moneyFormat);
                if (rrpPrice) {
                    rrpPrice.innerHTML = `(RRP: ${formatMoney(price, window.theme.moneyFormat)})`;
                }
            });
        // Josh Fix
    }

    
    let foundVideos = document.querySelectorAll('.clc-GridCta_BackgroundVideo video');
    let firstTime = true;
    const observer = new MutationObserver(() => {
        let newFoundVideos = document.querySelectorAll('.clc-GridCta_BackgroundVideo video');
        if (newFoundVideos.length > foundVideos.length || firstTime) {
            firstTime = false;
            console.log('TESTING. new video found');
            
            newFoundVideos.forEach(video => {
                video.style.display = 'none';
                video.pause();
                video.play();
                video.style.display = 'block';
            });
            foundVideos = newFoundVideos;
        }
    });
    observer.observe(document, { subtree: true, childList: true });


})